import { 
	GET_ADDRESS_BOOK_COMPANIES, 
	GET_ADDRESS_BOOK_COMPANY,
	CREATE_ADDRESS_BOOK_COMPANY,
	UPDATE_ADDRESS_BOOK_COMPANY,
	DESTROY_ADDRESS_BOOK_COMPANY,
} from "./actions"

export function AddressBookCompaniesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_ADDRESS_BOOK_COMPANIES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_ADDRESS_BOOK_COMPANY}_FULFILLED`:
		case `${CREATE_ADDRESS_BOOK_COMPANY}_FULFILLED`:
		case `${UPDATE_ADDRESS_BOOK_COMPANY}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_ADDRESS_BOOK_COMPANY}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { AddressBookCompaniesReducer } from "modules/address_book/companies/reducer"

// address_book_companies:AddressBookCompaniesReducer,
